import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
  errorInfo: ErrorInfo | null;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error, errorInfo: null };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    this.setState({ error, errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '40px', fontFamily: 'system-ui, sans-serif' }}>
          <h1 style={{ color: '#dc2626', fontSize: '24px', marginBottom: '16px' }}>
            Something went wrong
          </h1>
          <details style={{ whiteSpace: 'pre-wrap', marginBottom: '16px' }}>
            <summary style={{ cursor: 'pointer', marginBottom: '8px' }}>Error Details</summary>
            <p style={{ color: '#991b1b', background: '#fef2f2', padding: '16px', borderRadius: '8px' }}>
              {this.state.error && this.state.error.toString()}
            </p>
            <pre style={{ fontSize: '12px', overflow: 'auto', background: '#f3f4f6', padding: '16px', borderRadius: '8px' }}>
              {this.state.errorInfo && this.state.errorInfo.componentStack}
            </pre>
          </details>
          <p style={{ color: '#6b7280' }}>
            Check the browser console for more details.
          </p>
          <p style={{ marginTop: '16px', fontSize: '14px', color: '#9ca3af' }}>
            Environment variables loaded:
          </p>
          <ul style={{ fontSize: '12px', color: '#6b7280', marginTop: '8px' }}>
            <li>VITE_SUPABASE_URL: {import.meta.env.VITE_SUPABASE_URL ? '✓ Set' : '✗ Missing'}</li>
            <li>VITE_SUPABASE_ANON_KEY: {import.meta.env.VITE_SUPABASE_ANON_KEY ? '✓ Set' : '✗ Missing'}</li>
            <li>VITE_API_URL: {import.meta.env.VITE_API_URL ? '✓ Set' : '✗ Missing'}</li>
          </ul>
          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: '24px',
              padding: '12px 24px',
              background: '#3b82f6',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '14px',
            }}
          >
            Reload Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
